import { render } from "./FloatingButtons.vue?vue&type=template&id=0371380f"
import script from "./FloatingButtons.vue?vue&type=script&lang=js"
export * from "./FloatingButtons.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__